import Api, { axiosInstance } from '../Api';
export default class DataPreview {
  private endPoint = 'DataPreview';

  // get mesh Style and layer by preview id
  async getDataPreview(ids?: string) {
    try {
      const r = await axiosInstance.get(
        `/${this.endPoint}/GetDataPreview?ids=${ids}`
      );
      if (r && r.data && r.data.length > 0) {
        return r.data[0];
      } else {
        return {};
      }
    } catch (error) {
      return {};
    }
  }
}
